import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dcc8bde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ybtitle-tooltip" }
const _hoisted_2 = ["onMouseleave", "onMouseenter"]
const _hoisted_3 = { class: "ybtitle-tooltip" }
const _hoisted_4 = ["onMouseleave", "onMouseenter"]
const _hoisted_5 = { class: "ybtitle-tooltip" }
const _hoisted_6 = ["onMouseleave", "onClick", "onMouseenter"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下载 ")
const _hoisted_9 = { class: "red" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_12 = { class: "green" }
const _hoisted_13 = { class: "red" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_VerticalAlignBottomOutlined = _resolveComponent("VerticalAlignBottomOutlined")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    columns: _ctx.columns,
    "data-source": _ctx.data,
    loading: {spinning: _ctx.loading, tip:'加载中...'},
    size: "small",
    class: _normalizeClass(_ctx.theme),
    bordered: _ctx.bordered,
    pagination: false,
    "row-key": 'index',
    scroll: _ctx.scroll,
    "custom-cell": _ctx.handleClickRow,
    customRow: _ctx.clickRow,
    rowClassName: _ctx.setRowClassName,
    onChange: _ctx.onChange
  }, {
    name: _withCtx(({ text }) => [
      _createElementVNode("a", null, _toDisplayString(text), 1)
    ]),
    Index: _withCtx(({ record, text, index, column }) => [
      _createElementVNode("span", null, _toDisplayString(index + 1), 1)
    ]),
    top10Index: _withCtx(({ record, text, index, column }) => [
      _createElementVNode("span", {
        class: _normalizeClass({'top3bg': index < 3})
      }, _toDisplayString(index + 1), 3)
    ]),
    ellipsis: _withCtx(({ record, text, index, column }) => [
      _createVNode(_component_a_tooltip, {
        placement: "topLeft",
        visible: _ctx.overflow[column.key + record.index],
        align: {
          offset: [0, 4]
        },
        "mouse-enter-delay": 0.4,
        "get-popup-container": _ctx.getPopupContainer
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(text), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "overflow",
            href: "javascript:void(0)",
            onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(record, text, column)), ["stop"]),
            onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow($event, record, column)), ["stop"])
          }, _toDisplayString(text ? text : '—'), 41, _hoisted_2)
        ]),
        _: 2
      }, 1032, ["visible", "mouse-enter-delay", "get-popup-container"])
    ]),
    stockname: _withCtx(({ record, text, index, column }) => [
      _createVNode(_component_a_tooltip, {
        placement: "topLeft",
        visible: _ctx.overflow[column.key + record.index],
        align: {
          offset: [0, 4]
        },
        "mouse-enter-delay": 0.4,
        "get-popup-container": _ctx.getPopupContainer
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(text), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass(["overflow", {'joined': (_ctx.inOptionalData.indexOf(record.Inst + '.' + (record.Exch || '').toLowerCase()) > -1)}]),
            href: "javascript:void(0)",
            onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(record, text, column)), ["stop"]),
            onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow($event, record, column)), ["stop"])
          }, _toDisplayString(text ? text : '—'), 43, _hoisted_4)
        ]),
        _: 2
      }, 1032, ["visible", "mouse-enter-delay", "get-popup-container"])
    ]),
    link: _withCtx(({ record, text, index, column }) => [
      _createVNode(_component_a_tooltip, {
        placement: "topLeft",
        visible: _ctx.overflow[column.key + record.index],
        align: { offset: [0, 4] },
        "destroy-tooltip-on-hide": "",
        "mouse-enter-delay": 0.4,
        "get-popup-container": _ctx.getPopupContainer
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, _toDisplayString(text), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "overflow",
            href: "javascript:void(0)",
            onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(record, text, column)), ["stop"]),
            onClick: ($event: any) => (_ctx.gotolink($event, record, column)),
            onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow($event, record, column)), ["stop"])
          }, _toDisplayString(text || '—'), 41, _hoisted_6)
        ]),
        _: 2
      }, 1032, ["visible", "mouse-enter-delay", "get-popup-container"])
    ]),
    increase: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([text > 0 ? 'red' : text < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getPencent(text)), 3)
    ]),
    nocolorincrease: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getPencent(text)), 5)
    ]),
    decimal: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(2) : '—'), 5)
    ]),
    decimal4: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(4) : '—'), 5)
    ]),
    peopleCount: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getNumber(text)), 5)
    ]),
    peopleCountFixed2: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getNumber2(text)), 5)
    ]),
    download: _withCtx(({ record, text }) => [
      _createElementVNode("a", {
        class: "download",
        href: text.split(':')[1]
      }, [
        _createVNode(_component_VerticalAlignBottomOutlined),
        _hoisted_8
      ], 8, _hoisted_7)
    ]),
    peopleCountColor: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF'),
        class: _normalizeClass([text > 0 ? 'red' : text < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getNumber(text)), 7)
    ]),
    peopleCountColor2: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF'),
        class: _normalizeClass([record.increase > 0 ? 'red' : record.increase < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getNumber(text)), 7)
    ]),
    lastPrice: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([record.increase > 0 ? 'red' : record.increase < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getNumber2(text)), 3)
    ]),
    fluctuationDistribution: _withCtx(({ record, text }) => [
      ((text||{}).P || (text||{}).P ===0)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
          }, [
            _createElementVNode("strong", _hoisted_9, _toDisplayString((text||{}).Z), 1),
            _hoisted_10,
            _createElementVNode("strong", null, _toDisplayString((text||{}).P), 1),
            _hoisted_11,
            _createElementVNode("strong", _hoisted_12, _toDisplayString((text||{}).D), 1)
          ], 4))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
          }, "—", 4))
    ]),
    redInteger: _withCtx(({ record, text }) => [
      _createElementVNode("span", _hoisted_13, _toDisplayString(text?parseInt(text):0), 1)
    ]),
    hdTop: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass({'hdTop' : record.top3})
      }, [
        (record.top3)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require('@/assets/asking/images/fire_hover.png'),
              alt: ""
            }, null, 8, _hoisted_14))
          : _createCommentVNode("", true),
        _createElementVNode("strong", null, _toDisplayString(text), 1)
      ], 2)
    ]),
    includeStockInfp: _withCtx(({ record, text }) => [
      _createElementVNode("strong", null, _toDisplayString(text), 1),
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("small", null, _toDisplayString(record.symbol + '.' +record.market), 1)
    ]),
    _: 1
  }, 8, ["columns", "data-source", "loading", "class", "bordered", "scroll", "custom-cell", "customRow", "rowClassName", "onChange"]))
}